export default __webpack_public_path__ + "static/media/asset_management-dk.24e22e8d.svg";